/*
 * Author: Digital Zoom Studio
 * Website: http://digitalzoomstudio.net/
 * Portfolio: http://codecanyon.net/user/ZoomIt/portfolio
 *
 * Version: 0.9901
 */

"use strict";


import {REGEX_GRID, VIEW_ALLEGED_16_9_RATIO, VIEW_ISOTOPE_ITEM_CLASS, ZFOLIO_MODE} from "./config/_constants";
import {zfolioGetContentCon, zfolioInitialSetup, zfolioParseOptions} from "./js_zfolio/_zfolioHelpers";
import {add_query_arg, get_query_arg} from "./js_common/_dzs_helpers";
import {zfolioDefaultSettings} from "./config/_zfolioSettings";
import {structureGenerateOverlay} from "./js_zfolio/structure/_view_structureGenerateOverlay";
import {structureItemGenerateThumbCon} from "./js_zfolio/structure/_view_structureItemGenerateThumbCon";
import {viewGenerateStructureItemMeta} from "./js_zfolio/structure/_view_structureItemMeta";
import {zfolio_addJqueryHelpers} from "./js_zfolio/_jquery-helpers";
import {
  viewFilterCategory,
  zfolioCategoriesCalculateCatsArray,
  zfolioCategoriesGenerate
} from "./js_zfolio/_categoryHelpers";
import {ZFolio} from "./_class-zfolio";
import {zfolio_handleResize} from "./js_zfolio/_view-resize";
import {generate_grid_response} from "./js_zfolio/_viewHelpers";

window.dzszfl_self_options = {};

Math.easeIn = function (t, b, c, d) {

  return -c * (t /= d) * (t - 2) + b;

};



(function ($) {

  zfolio_addJqueryHelpers($);
  $.fn.zfolio = function (o) {



    o = zfolioParseOptions(o, this, $);

    this.each(function () {
      var  images
      ;
      var
        _paginationCon = null
        , _contentScroller = null
        , _contentScrollerItems = null
      ;
      var isDestroyed = false
        , view_isZfolioFaded = false
        , canLoadNextImagesFromScroll = false
        , view_canLoadImagesFromPrevLoaded = false
        , view_isFirstTimeLoadingImages = true // first time we allow
      ;
      var isAlreadyAdded = false;
      var
         inter_relayout = 0

      ;

      var mode_cols_nr_of_cols = 0
        , nr_per_page = 5
        ,
        class_all_temp_cols = ' temp-dzs-l-layout--1-cols temp-dzs-l-layout--2-cols temp-dzs-l-layout--3-cols temp-dzs-l-layout--4-cols temp-dzs-l-layout--5-cols temp-dzs-l-layout--6-cols'
      ;


      var modeNumberOfColumns = 0
        , i_dzscol_ind = 0;


      // -- thumbsize
      var design_item_thumb_height = 200
        , grid_unit_px = 200
        , isDesignHeightDynamic = false
        , layout_margin = 0
        , inter_relayout_allow = false
        , initial_cols_before_fallback = ''
      ;





      var arr_cats = [] // -- categories
        , arr_cats_type = 'datacategory' // -- categories
        , cat_curr = '*' // -- categories
      ;

      var categories_parent;


      // -- loading vars
      var
        images_toBeLoaded = []
        , $itemsArray = null
      ;



      const zfolioMain = new ZFolio(this, $, o);

      zfolioMain.htmlIdentifier = zfolioMain.cthis.attr('id');


      if (typeof zfolioMain.htmlIdentifier == 'undefined' || zfolioMain.htmlIdentifier === '') {
        var auxnr = 0;
        var temps = 'zoomfolio' + auxnr;

        while ($('#' + temps).length > 0) {
          auxnr++;
          temps = 'zoomfolio' + auxnr;
        }

        zfolioMain.htmlIdentifier = temps;
        zfolioMain.cthis.attr('id', zfolioMain.htmlIdentifier);
      }


      function handle_scroll(e, pargs) {
        var st = $(window).scrollTop();
        var cthis_ot = zfolioMain.cthis.offset().top;

        var wh = $(window).height();


        if (cthis_ot < st + wh + 50) {
          init();
        }
      }

      if (zfolioMain.mainOptions.init_on === 'init') {

        init();
      }
      if (o.init_on === 'scroll') {


        $(window).on('scroll.dzszfl_init_' + zfolioMain.htmlIdentifier, handle_scroll);
        handle_scroll();
      }


      function init() {
        $(window).off('scroll.dzszfl_init_' + zfolioMain.htmlIdentifier);


        if (zfolioMain.cthis.hasClass('dzszfl-inited')) {
          return false;
        }

        zfolioInitialSetup(zfolioMain.cthis, o);

        zfolioMain.initZfolio();



        if (!isNaN(Number(o.design_item_thumb_height))) {
          design_item_thumb_height = Number(o.design_item_thumb_height);


          isDesignHeightDynamic = design_item_thumb_height <= 3 && design_item_thumb_height > 0;
        } else {

        }
        if (!isNaN(Number(zfolioMain.cthis.attr('data-margin')))) {
          layout_margin = Number(zfolioMain.cthis.attr('data-margin'));
        }

        if (o.design_item_thumb_height === '') {
          o.design_item_thumb_height = 'proportional';
        }

        if (o.design_item_thumb_height === 'proportional') {
          zfolioMain.cthis.addClass('wait-until-item-loaded-then-visible');
          zfolioMain.cthis.addClass('items-depend-on-thumb-height');
        }




        nr_per_page = Number(o.settings_ajax_method_curritems_per_page);

        if (o.settings_ajax_method_curritems_per_page_initial) {
          nr_per_page = Number(o.settings_ajax_method_curritems_per_page_initial);
        }


        if (o.settings_mode === ZFOLIO_MODE.SCROLLER) {
          zfolioMain.cthis.append('<div  class="contentscroller auto-init2 bullets-right animate-height " data-margin="30">  <div class="items"></div></div>');

          _contentScroller = zfolioMain.cthis.find('.contentscroller');
          _contentScrollerItems = _contentScroller.find('.items');
        }


        zfolioMain.cthis.addClass('dzszfl-inited');

        reinit({
          'call_from': 'init'
        });

        init_ready();


        var $theContentCon = zfolioGetContentCon(zfolioMain.cthis);


        if ($theContentCon) {

          if ($theContentCon.hasClass('fullit')) {
            var gap = parseInt($theContentCon.find('.the-content').eq(0).attr('data-portfolio-gap'), 10);


            if (zfolioMain.cthis.hasClass('skin-melbourne') || zfolioMain.cthis.hasClass('skin-gazelia skin-gazelia--transparent')) {

              if (gap < 10) {
                gap = 10;
              }
            }
            if (isNaN(gap) === false) {
              $theContentCon.find('.translucent-layer').css({
                'padding': gap + 'px'
              })
              $theContentCon.find('.categories').eq(0).css({})
            }
          }

          $theContentCon.attr('data-filters-position', zfolioMain.cthis.attr('data-filters-position'));
        }


        $(window).on('scroll.dzszfl_' + zfolioMain.htmlIdentifier, handleScrollInner);


      }

      function handleScrollInner(e, pargs) {
        var st = $(window).scrollTop();
        var cthis_ot = zfolioMain.cthis.offset().top;


        zfolioMain.th = zfolioMain.cthis.height();


        if (o.pagination_method === 'scroll') {
          if (st + wh > cthis_ot + th - 20) {
            canLoadNextImagesFromScroll = true;

            loadBatchImages({
              call_scroll: false,
              'call_from': 'handle_scroll_inner'
            });
          } else {

            canLoadNextImagesFromScroll = false;
          }
        }


      }

      function reinit(pargs) {



        var margs = {
          'call_from': 'default'
        };

        if (pargs) {
          margs = $.extend(margs, pargs);
        }


        if (margs.call_from === 'ajax_append_new_items') {
          view_canLoadImagesFromPrevLoaded = true;
          canLoadNextImagesFromScroll = true;

        }

        var i = 1;
        i_dzscol_ind = 0;
        modeNumberOfColumns = 0;
        arr_cats = [];


        zfolioMain.$itemsCon.children('.zfolio-item:not(.inited)').each(function () {

          var $feedItem = $(this);


          $feedItem.addClass('dzs-l-layout-item');
          if ($feedItem.children().eq(0).hasClass('zfolio-item--inner') || $feedItem.children().eq(1).hasClass('zfolio-item--inner')) {


          } else {


            if ($feedItem.attr('data-link') && o.design_skin === 'skin-melbourne') {

              // -- for skin-melbourne

              let stringForMelbourne = '<a href="' + $feedItem.attr('data-link') + '" class="zfolio-item--inner ';


              if ($feedItem.attr('data-overlay_extra_class') && $feedItem.attr('data-overlay_extra_class').indexOf('content-opener') > -1) {

                stringForMelbourne += ' for-content-opener';
              }


              stringForMelbourne += 'custom-a "></a>';


              $feedItem.wrapInner(stringForMelbourne);
            } else {


              $feedItem.wrapInner('<div class="zfolio-item--inner"><div class="zfolio-item--inner--inner"><div class="zfolio-item--inner--inner--inner"></div></div></div>');
            }

          }

          if ($feedItem.attr('data-thumb')) {
            if (!$feedItem.attr('data-thumbnail')) {
              $feedItem.attr('data-thumbnail', $feedItem.attr('data-thumb'));
            }
          }

          var $itemInner = $feedItem.children('.zfolio-item--inner');
          var $itemInnerInner = $feedItem.find('.zfolio-item--inner--inner');
          var $itemInnerInnerInner = $feedItem.find('.zfolio-item--inner--inner--inner');

          if (o.item_inner_addid) {
            let stringId = '';

            if (zfolioMain.cthis.attr('id')) {
              stringId += zfolioMain.cthis.attr('id') + '-';
            }

            stringId += o.item_inner_addid + String(i);

            if (stringId) {
              $itemInner.attr('id', stringId);
            }
          }

          var stringStructTheFeatureCon = '';

          var isInsideAnchor = false;

          var item_link_thumb_con_to = o.item_link_thumb_con_to;
          if ($itemInner.get(0) && $itemInner.get(0).nodeName === 'A') {

            // -- todo: why ?
            if (item_link_thumb_con_to !== 'ultibox') {

              item_link_thumb_con_to = '';
            }
          }

          if (item_link_thumb_con_to === 'link') {
            isInsideAnchor = true;
          }

          stringStructTheFeatureCon = structureItemGenerateThumbCon(item_link_thumb_con_to, $feedItem);


          if ($itemInner.find('.the-feature-con').length) {

          } else {
            $itemInnerInnerInner.prepend(stringStructTheFeatureCon);
          }


          if ($itemInnerInnerInner.find('.item-meta').length) {

          } else {
            var aux_struct_item_meta = '';
            if ($feedItem.find('.feed-zfolio-the-title').length || $feedItem.find('.feed-zfolio-the-desc').length) {
              aux_struct_item_meta = viewGenerateStructureItemMeta($feedItem);
            }

            if (aux_struct_item_meta) {
              $itemInnerInnerInner.append(aux_struct_item_meta);
            }
          }

          const $thumbCon = $itemInner.find('.the-feature-con').eq(0);

          if (item_link_thumb_con_to === 'ultibox') {
            if ($itemInner.find('.feed-rst').length) {

              $thumbCon.append('<div class="feed-ultibox feed-ultibox-desc"><div class="rst-big-desc">' + $itemInner.find('.feed-rst').eq(0).html() + '</div></div>');
            }
          }


          if (item_link_thumb_con_to === 'ultibox') {

          }

          if (o.design_skin === 'skin-alba') {
            $itemInnerInner.append('<figure class="line1"></figure><figure class="line1"></figure><figure class="line1"></figure><figure class="line1"></figure>')
          }


          if (o.design_item_thumb_just_use_img === 'on') {


            let stringTheFeatureImage = '<img class="the-feature';

            if (o.use_scroll_lazyloading_for_images === 'on') {

              stringTheFeatureImage += ' lazyloading-transition-fade set-height-auto-after-load" data-src="' + $feedItem.attr('data-thumbnail') + '"';
              stringTheFeatureImage += '" style="height:300px; display:block;"';
            } else {

              stringTheFeatureImage += '" src="' + $feedItem.attr('data-thumbnail') + '"';
            }

            stringTheFeatureImage += '/>';

            $thumbCon.prependOnce(stringTheFeatureImage);

            $thumbCon.addClass('auto-height');

          } else {

            $thumbCon.prependOnce('<div class="the-feature the-feature-div" style="background-image: url(' + $feedItem.attr('data-thumbnail') + ');"></div>');
          }

          if (!$feedItem.attr('data-thumbnail')) {
            $thumbCon.addClass('no-preset-thumbnail')
          }


          if ($itemInner.find('.feed-zfolio-append-feature-con').length) {
            $thumbCon.append($itemInner.find('.feed-zfolio-append-feature-con').eq(0));
          }
          $itemInner.find('.the-feature-con')


          let overlay_extra_class = '';

          if ($feedItem.attr('data-overlay_extra_class')) {
            overlay_extra_class += ' ' + $feedItem.attr('data-overlay_extra_class');
          }


          let stringOverlayStruct = structureGenerateOverlay(isInsideAnchor, overlay_extra_class, $feedItem.attr('data-link'), o.design_skin, $feedItem);


          $itemInner.find('.the-feature-con').eq(0).appendOnce(stringOverlayStruct);


          if (o.design_skin === 'skin-gazelia') {

            if ($feedItem.children('.the-overlay-anchor').length > 0) {
              $feedItem.find('.the-overlay').eq(0).append($feedItem.children('.the-overlay-anchor').eq(0))
            }
          }

          if (o.design_skin === 'skin-lazarus') {
            if ($feedItem.children('.the-overlay-anchor').length > 0) {
              $feedItem.find('.the-overlay').eq(0).append($feedItem.children('.the-overlay-anchor').eq(0))
            }
          }

          if (o.design_skin === 'skin-material') {

            let $itemMeta = $feedItem.find('.item-meta').eq(0);
            let $theFeatureCon = $feedItem.find('.the-feature-con').eq(0);

            if ($itemMeta.length) {
              $theFeatureCon.before($itemMeta.find('.the-title'));
            }
          }



          $feedItem.addClass(o.item_extra_class);

          $feedItem.addClass('inited');

          $feedItem.attr('data-sort', zfolioMain.$itemsCon.children('.zfolio-item').index($feedItem) * 10);


          // -- deprecated

          let catsString = $feedItem.attr('data-category');
          if (catsString) {
            zfolioCategoriesCalculateCatsArray(catsString, $feedItem, arr_cats);
          }
          // -- deprecated END


          var the_cats_regex = /termid-(\d+)/ig;


          var aux = null;

          while (aux = the_cats_regex.exec($feedItem.attr('class'))) {

            var the_cat = aux[1];


            isAlreadyAdded = false;

            for (let k = 0; k < arr_cats.length; k++) {
              if (arr_cats[k] === the_cat) {
                isAlreadyAdded = true;
              }
            }
            if (!isAlreadyAdded) {
              arr_cats.push(the_cat);
            }

            arr_cats_type = 'dataterm';
          }


          i++;


          if (o.design_item_thumb_height === 'proportional') {
            let imageToBeLoaded = {
              'image': $feedItem.attr('data-thumbnail'),
              'item': $feedItem,
               'loaded': "off"
            }

            images_toBeLoaded.push(imageToBeLoaded);
          }
          if (o.design_item_thumb_height === 1) {
            let imageToBeLoaded = {
              'image': $feedItem.attr('data-thumbnail')
              , 'item': $feedItem
              , 'loaded': "off"
            }

            images_toBeLoaded.push(imageToBeLoaded);
          }


          if (o.settings_mode === ZFOLIO_MODE.SCROLLER) {

            $feedItem.addClass('csc-item');
            _contentScrollerItems.append($feedItem);
          }
        });


        if (o.settings_mode === ZFOLIO_MODE.SCROLLER) {
          if (window.dzscsc_init) {

            if (o.scroller_settings.per_row === 'default') {

              if (zfolioMain.cthis.hasClass('dzs-l-layout--5-cols')) {
                o.scroller_settings.per_row = '5';
              }
              if (zfolioMain.cthis.hasClass('dzs-l-layout--3-cols')) {
                o.scroller_settings.per_row = '3';
              }
              if (zfolioMain.cthis.hasClass('dzs-l-layout--1-cols')) {
                o.scroller_settings.per_row = '1';
              }

            }

            if (o.scroller_settings.per_row === 'default') {
              o.scroller_settings.per_row = '4';
            }

            if (o.scroller_settings.per_row === '1') {
              o.scroller_settings.settings_onlyone = 'on';
            }

            dzscsc_init(_contentScroller, o.scroller_settings)
          }
        }

        // -- still reinit()


        if (o.outer_con_selector_con) {

          if (o.outer_con_selector_con.off) {

          } else {
            (o.outer_con_selector_con) = $(o.outer_con_selector_con)
          }

          zfolioMain._selectorCon = (o.outer_con_selector_con);
        }

        if (arr_cats.length > 1 && zfolioMain.cthis.find('.selector-con').length === 0) {

          var aux = '<div class="selector-con ' + o.selector_con_skin + '"><div class="categories">';
          aux += '</div></div>';


          if (o.outer_con_selector_con) {

            zfolioMain._selectorCon = (o.outer_con_selector_con);
          } else {

            zfolioMain.$itemsCon.before(aux);
            zfolioMain._selectorCon = zfolioMain.cthis.find('.selector-con').eq(0);
          }


        } else {
          if (o.outer_con_selector_con) {

            zfolioMain._selectorCon = $(o.outer_con_selector_con);
            zfolioMain._selectorCon.addClass('empty-categories');


          }
        }


        if (zfolioMain._selectorCon && zfolioMain._selectorCon.children) {
          categories_parent = zfolioMain._selectorCon.children('.categories');


          if (categories_parent.find('.a-category').length) {

            if (o.selector_con_generate_categories === 'auto') {
              o.selector_con_generate_categories = 'off';
            }
          }

          if (o.selector_con_generate_categories === 'auto') {
            o.selector_con_generate_categories = 'on';
          }


          if (o.filters_enable === 'off') {
            zfolioMain._selectorCon.hide();
          }


          if (zfolioMain.cthis.find('.feed-zfolio-zfolio-term').length) {
            arr_cats = [];

            zfolioMain.cthis.find('.feed-zfolio-zfolio-term').each(function () {
              const _t = $(this);

              arr_cats.push(_t.attr('data-termid'));
              zfolioMain.cthis.addClass('has-filters');
            })
            ;
          }


          if (o.selector_con_generate_categories === 'off') {


          } else {

            zfolioCategoriesGenerate(categories_parent, o, zfolioMain._selectorCon, arr_cats, zfolioMain.cthis,arr_cats_type, zfolioMain.htmlIdentifier);
          }


        }


        images = zfolioMain.$itemsCon.children();

        if (o.design_item_thumb_height === 'proportional') {
          loadBatchImages({
            call_scroll: false
            , 'call_from': 'reinit'
          });
        }


      }

      function init_ready() {

        zfolioMain.initZfolioReady();

        // Check if this is an isotope layout by looking at both settings and CSS classes
        if (o.settings_mode === 'isotope') {

          if (o.design_item_thumb_height !== 'proportional') {

            zfolioMain.$itemsCon.children('*:not(.grid-sizer):not(.gutter-sizer)').addClass(VIEW_ISOTOPE_ITEM_CLASS);
          }




          checkIfIsotopeIsReady().then(function() {
            init_isotope();

            // Only call handle_resize after Isotope is initialized
            handle_resize();
            $(window).on('resize.dzszfl_' + zfolioMain.htmlIdentifier, handle_resize);
          });

        } else {
          // For non-isotope modes, call handle_resize immediately
          handle_resize();
          $(window).on('resize.dzszfl_' + zfolioMain.htmlIdentifier, handle_resize);
        }

        if (o.pagination_selector) {
          o.pagination_selector = $(o.pagination_selector);
          _paginationCon = o.pagination_selector;
        }


        if (zfolioMain._selectorCon) {

          zfolioMain._selectorCon.off('click', '.a-category');
          zfolioMain._selectorCon.on('click', '.a-category', handle_mouse);
        }

        if (o.outer_con_search_con) {
          var _c = o.outer_con_search_con;

          _c.on('keyup', handle_key);
        }

        if (_paginationCon) {

          _paginationCon.find('a').addClass('dzszfl-pagination-a custom-a');
          _paginationCon.on('click', 'a', handle_mouse);
        }
        zfolioMain.cthis.on('click', '.content-opener', click_contentOpener);


        zfolioMain.cthis.get(0).api_destroy = destroy;
        zfolioMain.cthis.get(0).api_handle_resize = handle_resize;
        zfolioMain.cthis.get(0).api_destroy_listeners = destroy_listeners;
        zfolioMain.cthis.get(0).api_relayout_isotope = function () {

          if (inter_relayout_allow) {

            clearTimeout(inter_relayout);
            inter_relayout = setTimeout(calculate_dims_only_relayout, 500);
          }

        };


        setTimeout(function () {
          inter_relayout_allow = true;
        }, 2500)



        if (o.settings_defaultCat === '') {
          if (get_query_arg(window.location.href, 'dzsp_defCategory_' + zfolioMain.htmlIdentifier)) {


            const ind = get_query_arg(window.location.href, 'dzsp_defCategory_' + zfolioMain.htmlIdentifier);


            if (categories_parent) {
              categories_parent.children().eq(ind).trigger('click');

            }


          }
        } else {
          goto_category(o.settings_defaultCat, {
            'class_name': 'termid'
          })
        }


        setTimeout(function () {
          const calculateDimsArgs = {

            'parse_items': true,
             'relayout_isotope': true,
             'disable_easing_on_isotope_transiton': false
          };
          calculate_dims(calculateDimsArgs);
        }, 2500);


        if (o.design_item_height === 0) {

          setTimeout(function () {

            init_allReady();
          }, 1200);

        } else {


          setTimeout(function () {
            init_allReady();
          }, 1200);
        }

        if (o.settings_mode === ZFOLIO_MODE.SCROLLER) {
          setTimeout(function () {
            zfolioMain.cthis.addClass('inited-scroller-ready');
          }, 1000);
        }

      }



      function checkIfIsotopeIsReady() {
        return new Promise((resolve, reject) => {
          let checkInterval = setInterval(() => {
            let isIsotopeReady = false;


            if (zfolioMain.mainOptions.layoutMode === 'packery') {

              zfolioMain.lcIsPackeryReady = !!$.fn.packery;
            }
            if ($.fn.isotope) {
              isIsotopeReady = true;
            }

            if (isIsotopeReady) {

              clearInterval(checkInterval);
              resolve();
            }

          }, 30);
        })
      }

      function init_isotope() {
        zfolioMain.initIsotopeSettings();

        let isotopeSettings = {};


        isotopeSettings.transitionDuration = '0s';
        zfolioMain.applyIsotope(isotopeSettings);



        zfolioMain.$itemsCon.addClass('isotoped');

        zfolioMain.$itemsCon.children('.' + VIEW_ISOTOPE_ITEM_CLASS).addClass('isotoped-item');

        zfolioMain.tempInterSetTransitionAnimation = setTimeout(function () {
          isotope_applyTransitionDuration();
        }, 3000);
      }

      function isotope_applyTransitionDuration(){

        zfolioMain.applyIsotope(null,{
          transitionDuration: '0.4s'
        });

        zfolioMain.cthis.addClass('dzszfl-ready-for-transitions');
      }

      /**
       *
       */
      function init_allReady() {

        clearTimeout(zfolioMain.tempInterSetTransitionAnimation);

        if (zfolioMain.$itemsCon.css('opacity') === '0') {

        }


        zfolioMain.cthis.removeClass('set-height-when-final');
        zfolioMain.cthis.addClass('dzszfl-ready');


        isotope_applyTransitionDuration();

        zfolioMain.$itemsCon.on('removeComplete',
          function (event, removedItems) {
            console.log('Removed ' + removedItems.length + ' items');
          }
        );
      }

      function categoriesHandleClickAllCategories(e){
        const $t = $(this);

      }

      function handleImageLoaded(e) {

        var $img_ = this;


        if (e.type === 'error') {

          images_toBeLoaded[$img_.indexinarr].loaded = "error";
        } else {

          images_toBeLoaded[$img_.indexinarr].loaded = "on";
        }


        const $zfolioItem = $img_.item;

        const nw = $img_.naturalWidth;
        const nh = $img_.naturalHeight;

        const perc = Number(nw / nh).toFixed(3);

        $zfolioItem.find('.the-feature').attr('naturalwidth', nw);
        $zfolioItem.find('.the-feature').attr('naturalheight', nh);
        $zfolioItem.find('.the-feature').attr('n_perc', perc);
        $zfolioItem.find('.the-feature').css('padding-top', (1 / perc * 100) + '%');

        $zfolioItem.addClass('padding-set');

        view_checkIfItemsCanShow({
          'call_from': 'image_onload',
          'call_scroll': false
        });

      }

      function loadBatchImages(pargs) {


        // -- lets see first if it needs loading :D

        var margs = {

          'call_scroll': true
          , 'call_from': 'default'
        };


        if (pargs) {
          margs = $.extend(margs, pargs);
        }


        if (!(view_isFirstTimeLoadingImages || (o.pagination_method === 'normal' && view_canLoadImagesFromPrevLoaded) || (o.pagination_method === 'scroll' && canLoadNextImagesFromScroll))) {
          return;
        }


        if (images_toBeLoaded && images_toBeLoaded.length) {


          let bufferPerPage = 0;

          for (let i in images_toBeLoaded) {

            if (images_toBeLoaded[i].loaded === "on" || images_toBeLoaded[i].loaded === "set" || images_toBeLoaded[i].loaded === "error") {
              continue;
            }

            const newImage = new Image();
            newImage.src = images_toBeLoaded[i].image;
            newImage.item = images_toBeLoaded[i].item;
            newImage.indexinarr = i;


            if (margs.call_from !== 'handle_scroll_inner') {
            }
            newImage.onload = handleImageLoaded;
            newImage.onerror = handleImageLoaded;

            images_toBeLoaded[i].loaded = "loading";


            bufferPerPage++;
            if (bufferPerPage >= nr_per_page && !zfolioMain.cthis.hasClass('pagination-method-off')) {
              break;
            }
          }


          view_canLoadImagesFromPrevLoaded = false;
          canLoadNextImagesFromScroll = false;


          if (view_isFirstTimeLoadingImages) {
            nr_per_page = Number(o.settings_ajax_method_curritems_per_page);
          }
          view_isFirstTimeLoadingImages = false;

          setTimeout(function () {

            // -- it s not from here

            if (margs.call_scroll) {

              handleScrollInner(null, {})
            }
          }, 100);
        }

      }

      /**
       * call from image_onload
       * @param pargs
       */
      function view_checkIfItemsCanShow(pargs) {


        let margs = {

          'call_scroll': true
          , 'call_from': 'default'
        };


        if (pargs) {
          margs = $.extend(margs, pargs);
        }


        // -- deprecated


        let isGoingToNextItems = true;
        for (let i in images_toBeLoaded) {

          if (images_toBeLoaded[i].loaded === "loading") {
            isGoingToNextItems = false;
          }
        }


        if (isGoingToNextItems) {


          zfolioMain.$itemsCon.children().removeClass('new-item');
          for (let i in images_toBeLoaded) {

            if (images_toBeLoaded[i].loaded === "on" || zfolioMain.cthis.hasClass('pagination-method-off')) {
              var $zfolioItem = images_toBeLoaded[i].item;

              $zfolioItem.addClass(VIEW_ISOTOPE_ITEM_CLASS);

              if (!$zfolioItem.hasClass('isotoped-item')) {
                $zfolioItem.addClass('new-item');
              }


              images_toBeLoaded[i].loaded = 'set';


              setTimeout(function ($zfolioItem$) {
                $zfolioItem$.addClass('loaded');
              }, 1000, $zfolioItem);


            }
          }

          let $newItems = zfolioMain.$itemsCon.children('.new-item');


          checkIfIsotopeIsReady().then(() => {
            isotope_appendNewItems($newItems);
          })

          setTimeout(function () {
            zfolioMain.$itemsCon.children().removeClass('new-item');
          }, 1000);


          calculate_dims_the_feature_div();


          view_canLoadImagesFromPrevLoaded = true;


          loadBatchImages({
            'call_from': 'check_if_items_can_show'
          });


          setTimeout(function () {
            calculate_dims_only_relayout();
          }, 500);
        }
      }

      function isotope_appendNewItems($newItems) {


        zfolioMain.$itemsCon.isotope('appended', $newItems);
      }


      function fadeout_and_destroy_items() {


        view_isZfolioFaded = true;


        // -- new page


        const aux_scroll_pos = zfolioMain.cthis.offset().top - 100;

        const $scrollerScrollTop = $('.scroller-con.type-scrollTop');
        if ($scrollerScrollTop.get(0) && $scrollerScrollTop.get(0).api_scrolly_to) {

          $scrollerScrollTop.get(0).api_scrolly_to(aux_scroll_pos);
        } else {

          $('html, body').css({
            scrollTop: aux_scroll_pos
          }, 300);
        }

        zfolioMain.$itemsCon.css({
          'opacity': 0
        })


      }

      function destroy_items() {


        if (o.settings_mode === 'isotope') {


        }

      }

      function ajax_append_new_items(arg, pargs) {


        var margs = {
          'call_from': "default"
        };


        if (pargs) {
          margs = $.extend(margs, pargs);
        }


        if (view_isZfolioFaded) {
          setTimeout(function () {
            ajax_append_new_items(arg);
          }, 500);


          return false;
        }


        zfolioMain.$itemsCon.children('.zfolio-item').addClass('old-item');


        if (o.settings_mode === 'isotope') {

          zfolioMain.$itemsCon.children('.zfolio-item.old-item').each(function () {
            var _t3 = $(this);
            zfolioMain.$itemsCon.isotope('remove', _t3);
          })

          setTimeout(function () {
          }, 10);
          setTimeout(function () {

          }, 300);
        }

        setTimeout(function () {
          zfolioMain.$itemsCon.append(arg);


          if (o.settings_mode === 'isotope') {

            zfolioMain.$itemsCon.children('*:not(.grid-sizer):not(.gutter-sizer)').addClass(VIEW_ISOTOPE_ITEM_CLASS);


            var _newitems = zfolioMain.$itemsCon.children('*:not(.grid-sizer):not(.gutter-sizer):not(.old-item)');

            if (zfolioMain.cthis.hasClass('thumbnail-height-mode-normal')) {
              zfolioMain.$itemsCon.isotope('appended', _newitems);
            }


            setTimeout(function () {


              calculate_dims({

                'parse_items': true
                , 'relayout_isotope': true
                , 'disable_easing_on_isotope_transiton': false
              });


              zfolioMain.$itemsCon.isotope('layout');
            }, 500)

            setTimeout(function () {

            }, 1500)

          }
          reinit({
            'call_from': 'ajax_append_new_items'
          });

          setTimeout(function () {

            if (zfolioMain.cthis.hasClass('thumbnail-height-mode-normal')) {
            }
            calculate_dims();
          })


          setTimeout(function () {
            zfolioMain.$itemsCon.css({
              'opacity': 1
            }, {
              queue: false
              , duration: 300
              , complete: function () {

              }
            })

            if (zfolioMain._selectorCon) {

              zfolioMain._selectorCon.css({
                'opacity': 1
              }, {
                queue: false
                , duration: 300
              })
            }
            if (_paginationCon) {

              _paginationCon.css({
                'opacity': 1
              }, {
                queue: false
                , duration: 300
              })
            }
          }, 1000);
        }, 300);


      }

      function destroy_listeners() {


        if (o.settings_mode === 'isotope' && $.fn.isotope) {


          try {

            zfolioMain.$itemsCon.isotope('destroy');
          } catch (err) {
          }
        }


        zfolioMain.cthis.off('click');

        $(window).off('resize.dzszfl_' + zfolioMain.htmlIdentifier);
        $(window).off('scroll.dzszfl_' + zfolioMain.htmlIdentifier);
        isDestroyed = true;

      }

      function destroy() {

        if (o.settings_mode === 'isotope' && $.fn.isotope) {


          try {

          } catch (err) {
          }
        }
        isDestroyed = true;

      }

      function handle_key(e) {
        var _t = $(this);


        if (e.type === 'keyup') {
          if (o.settings_mode === 'isotope') {
            zfolioMain.$itemsCon.isotope({
              filter: function () {
                var name = $(this).find('.item-meta').eq(0).text();
                var ok = false;

                var regex = new RegExp('.*' + _t.val() + '.*');

                if (name.match(regex)) {
                  ok = true;
                }


                return ok;
              }
            });
          }
          if (o.settings_mode === 'simple') {
            zfolioMain.$itemsCon.children().fadeOut('fast');
            zfolioMain.$itemsCon.children(value).fadeIn('fast');
          }
        }
      }



      function handle_mouse(e) {
        var _t = $(this);

        if (e.type === 'click') {
          if (_t.hasClass('a-category')) {

            var isReturningFalse = viewFilterCategory(zfolioMain, _t, zfolioMain.$itemsCon, o, goto_category );

            if(_t.hasClass('category-all-selector')){
            }

            if (isReturningFalse) {
              if(zfolioMain._selectorCon.hasClass("selector-responsive-mode")){

                zfolioMain._selectorCon.toggleClass('selector-responsive-mode--is-expanded');
              }
              return false;
            }

          }
          if (_t.hasClass('dzszfl-pagination-a')) {


            if (_t.hasClass('active') || _t.parent().hasClass('active') || _t.attr('href') === '#') {

              return false;
            }


            fadeout_and_destroy_items();


            $.ajax({
              url: _t.attr('href'),
              context: document.body
            }).done(function (response) {

              ajax_append_new_items(response, {
                'call_from': 'ajax-pagination'
              });


            });


            _t.parent().parent().find('.active').removeClass('active');

            _t.parent().addClass('active');


            return false;
          }
        }
      }

      function handle_resize(e, pargs) {

        zfolio_handleResize(zfolioMain, pargs, excerpt_content_resize_vplayer.bind(this), calculate_dims.bind(this))
      }

      function calculate_dims_the_feature_div() {


      }

      function excerpt_content_resize_vplayer() {


        if (zfolioMain._excerptContent && zfolioMain._excerptContent.find('.vplayer').length > 0) {

          var _c = zfolioMain._excerptContent.find('.vplayer').eq(0);


          var auxr = Number(o.excerpt_con_responsive_ratio);
          var excerpt_width = zfolioMain._excerptContent.width();

          if (_c.parent().hasClass('dzs-col-8')) {
            auxr *= 2 / 3;

            if (o.excerpt_con_responsive_ratio === 810) {
              auxr = 580;


              if (zfolioMain.ww <= 1000) {
              }

            }

          }

          var auxih = 0;


          if (_c.data('initial-height-for-excerpt-content')) {
            auxih = Number(_c.data('initial-height-for-excerpt-content'));
          } else {

            auxih = VIEW_ALLEGED_16_9_RATIO * zfolioMain._excerptContent.width();
            if (_c.parent().hasClass('dzs-col-8')) {

              auxih = VIEW_ALLEGED_16_9_RATIO * _c.parent().width();
            }
            _c.data('initial-height-for-excerpt-content', auxih);
          }


          var aux_ratio = auxih / auxr;


          _c.height(auxih);


        }


      }

      function calculate_dims(pargs) {


        var margs = {

          'parse_items': true
          , 'relayout_isotope': true
          , 'disable_easing_on_isotope_transiton': false
        };


        var registered_heights = [];
        var registered_end_pos = [];
        var sw_recheck_at_end = false; // -- recheck all item so that they align with the others nicely

        if (pargs) {
          margs = $.extend(margs, pargs);
        }

        if (isDestroyed) {
          return;
        }


        zfolioMain.th = zfolioMain.cthis.height();
        zfolioMain.wh = window.innerHeight;
        var breaker = 20;


        if (margs.parse_items) {

          i_dzscol_ind = 0;

          modeNumberOfColumns = 0;

          $itemsArray = zfolioMain.$itemsCon.children('.zfolio-item');


          if (o.settings_mode === ZFOLIO_MODE.SCROLLER) {
            $itemsArray = _contentScroller.find('.thumbsCon').children('.zfolio-item');
          }


          $itemsArray.each(function () {


            let aux;
            const $theItem = $(this);


            let aux_iw = -1;

            var aux_tw = zfolioMain.cthis.width();




            var temp_layout = '';


            zfolioMain.cthis.removeClass(class_all_temp_cols);
            const aux_grid_response = generate_grid_response(zfolioMain);

            aux_iw = aux_grid_response.aux_iw;
            grid_unit_px = aux_grid_response.grid_unit_px;
            initial_cols_before_fallback = aux_grid_response.nr_cols;


            zfolioMain.cthis.removeClass('temp-dzs-l-layout--2-cols');

            if (zfolioMain.cthis.hasClass('dzs-l-layout--6-cols')) {


              zfolioMain.cthis.attr('data-nr-cols', '6');

            }

            if (zfolioMain.cthis.hasClass('dzs-l-layout--5-cols')) {

              zfolioMain.cthis.attr('data-nr-cols', '5');


            }


            if (zfolioMain.cthis.hasClass('dzs-l-layout--4-cols')) {


              zfolioMain.cthis.attr('data-nr-cols', '4');
            }


            if (zfolioMain.cthis.hasClass('dzs-l-layout--3-cols')) {


              zfolioMain.cthis.attr('data-nr-cols', '3');
            }


            if (zfolioMain.cthis.hasClass('dzs-l-layout--2-cols')) {


            }





            zfolioMain.cthis.addClass(temp_layout);


            grid_unit_px = parseInt(grid_unit_px, 10);


            if (o.settings_mode !== ZFOLIO_MODE.SCROLLER) {
              $theItem.css('width', '');
            }

            if (o.settings_set_forced_width === 'on') {

              if (o.settings_mode !== ZFOLIO_MODE.SCROLLER) {

                $theItem.outerWidth(aux_iw);
              }

            }


            // -- dynamic SCALING

            if (isDesignHeightDynamic) {

              sw_recheck_at_end = true;
              if (design_item_thumb_height <= 2) {


                var wexpand = 1;
                var hexpand = 1;


                if ($theItem.attr('data-hexpand')) {

                  hexpand = Number($theItem.attr('data-hexpand'));

                }


                if ($theItem.attr('data-wexpand')) {

                  wexpand = Number($theItem.attr('data-wexpand'));

                }

                var orig_hexpand = hexpand;

                hexpand = hexpand / wexpand;


                let finalw = wexpand * aux_iw;

                if (Number(finalw) > 99) {
                  finalw = 100;
                }
                if (aux_iw > 0) {
                  if (o.settings_mode !== ZFOLIO_MODE.SCROLLER) {
                    $theItem.css('width', finalw + '%');
                  }
                }


                if ($theItem.width() < 300) {
                  $theItem.addClass('under-300');
                } else {

                  $theItem.removeClass('under-300');
                }


                let targetHeight = 0;


                targetHeight = (hexpand * design_item_thumb_height * ($theItem.width())) + ((hexpand - 1));


                for (let i2 in registered_heights) {

                  var ncach = registered_heights[i2];


                  if (targetHeight === ncach - 1 || targetHeight === ncach + 1) {
                    targetHeight = ncach;
                  }
                }

                if ($.inArray(targetHeight, registered_heights) > -1) {

                } else {
                  registered_heights.push(targetHeight);
                }


                // TODO: we dont need this anymore

                var view_isCustomLayout = false;

                if (zfolioMain.cthis.hasClass('custom-layout')) {
                  view_isCustomLayout = true;
                }




                if (view_isCustomLayout) {


                  $theItem.find('.zfolio-item--inner').css({
                    'padding-top': (hexpand * 100) + '%'
                  })
                  $theItem.addClass('padding-set');
                } else {


                  // -- this is it
                  $theItem.find('.the-feature-con').eq(0).css({
                    'padding-top': (design_item_thumb_height * 100) + '%'
                  })
                  $theItem.addClass('padding-set');


                  if (o.design_skin === 'skin-silver') {

                  }
                }




              }
            } else {
            }
          });


          if (sw_recheck_at_end) {

          }

          if (modeNumberOfColumns) {
            mode_cols_nr_of_cols = modeNumberOfColumns;
          }
        }


        if (margs.relayout_isotope) {

          if (margs.disable_easing_on_isotope_transiton) {

            var args = {};
            args = $.extend(args, o.settings_isotope_settings);

            args.transitionDuration = '0s';

            zfolioMain.$itemsCon.isotope(args);

            zfolioMain.$itemsCon.children('.' + VIEW_ISOTOPE_ITEM_CLASS).addClass('isotoped-item');

            setTimeout(function () {


            }, 500);
          } else {

            if (o.settings_mode === 'isotope' && zfolioMain.$itemsCon.hasClass('isotoped')) {

              if (zfolioMain.$itemsCon && !isDestroyed) {


                zfolioMain.$itemsCon.isotope('layout');
              }
            }

          }

          setTimeout(function () {
            if (o.settings_mode === 'isotope' && zfolioMain.$itemsCon.hasClass('isotoped')) {
              if (zfolioMain.$itemsCon && !isDestroyed) {
                zfolioMain.$itemsCon.isotope('layout');
              }
            }
          }, 500);
        }

        if (window.dzs_check_lazyloading_images) {
          window.dzs_check_lazyloading_images();
        }
      }


      function calculate_dims_only_relayout() {


        var args = {

          'parse_items': false
          , 'relayout_isotope': true
          , 'disable_easing_on_isotope_transiton': false
        };

        calculate_dims(args);
      }


      function goto_category(arg, args) {


        var margs = {
          'call_from': 'default'
          , 'class_name': 'cat'
        }


        if (args) {
          margs = $.extend(margs, args);
        }

        var options = {};
        var key = "filter";

        var value = '.' + margs.class_name + '-' + arg;
        if (!arg || arg === "*" || arg === o.settings_categories_strall) {
          value = "*";
        }

        if (cat_curr === value) {
          return false;
        }


        cat_curr = value;
        if (categories_parent) {
          categories_parent.children().removeClass('active');


          categories_parent.children().each(function () {
            var _t = $(this);

            if (_t.text() === arg) {
              _t.addClass('active');
            }


            if (margs.class_name === 'termid') {
              if (_t.attr('data-termid') === arg) {
                _t.addClass('active');

              }
            }
          })
        }

        value = value === "false" ? false : value;

        value = value.replace(/ /gi, '-');

        if (o.settings_mode === ZFOLIO_MODE.SCROLLER) {

          if ($itemsArray) {

            $itemsArray.each(function () {
              var _t = $(this);

              if (value === '*') {
                _t.removeClass('filtered-out');


              } else {


                if (_t.hasClass(value.replace('.', ''))) {

                  _t.removeClass('filtered-out');
                } else {
                  _t.addClass('filtered-out');

                }
              }
            })
          }
        }
        if (o.settings_mode === ZFOLIO_MODE.ISOTOPE) {


          zfolioMain.setIsotopeKey(key, value);
          zfolioMain.applyIsotope({});

          setTimeout(function () {

            zfolioMain.applyIsotope({});
          }, 500);
        }
        if (o.settings_mode === 'simple') {
          zfolioMain.$itemsCon.children().fadeOut('fast');
          zfolioMain.$itemsCon.children(value).fadeIn('fast');
        }


      }

      function click_contentOpener(e) {
        var _t = $(this);
        var ind = -1;
        zfolioMain._excerptContent_initialPortItem = null;

        // --trial and error
        if (_t.parent().hasClass('zfolio-item')) {
          zfolioMain._excerptContent_initialPortItem = _t.parent();
        } else {
          if (_t.parent().parent().hasClass('zfolio-item')) {
            zfolioMain._excerptContent_initialPortItem = _t.parent().parent();
          } else {
            if (_t.parent().parent().parent().hasClass('zfolio-item')) {
              zfolioMain._excerptContent_initialPortItem = _t.parent().parent().parent();
            } else {
              if (_t.parent().parent().parent().parent().hasClass('zfolio-item')) {
                zfolioMain._excerptContent_initialPortItem = _t.parent().parent().parent().parent();
              } else {
                if (_t.parent().parent().parent().parent().parent().hasClass('zfolio-item')) {
                  zfolioMain._excerptContent_initialPortItem = _t.parent().parent().parent().parent().parent();
                }
              }
            }
          }
        }

        // -- no point in continuing if tcon is not found


        if (zfolioMain._excerptContent_initialPortItem == null) {
          return false;
        }
        if (zfolioMain._excerptContent_initialPortItem.hasClass('active')) {
          contentOpener_close();
          return false;
        } else {
          if (zfolioMain._excerptContentCon) {
            contentOpener_close();
            zfolioMain._excerptContent_initialPortItem.parent().children().removeClass('active');
            setTimeout(function () {
              _t.click();
            }, 750)
            return false;
          }
        }


        var tcon_y = zfolioMain._excerptContent_initialPortItem.offset().top;

        var sw = false;
        var _tcon_next = null;

        while (!sw) {
          if (_tcon_next) {
            _tcon_next = _tcon_next.next();
            ;
          } else {
            _tcon_next = zfolioMain._excerptContent_initialPortItem.next();
          }


          if (_tcon_next.hasClass('zfolio-item')) {

            if (_tcon_next.offset().top !== tcon_y) {
              sw = true;
              ind = _tcon_next.parent().children('.' + VIEW_ISOTOPE_ITEM_CLASS).index(_tcon_next);
            }

          } else {
            sw = true;
          }
        }


        var excerptContent_extraClasses = '';
        var portclass = zfolioMain._excerptContent_initialPortItem.attr('class');
        portclass += ' ';


        var aux_regex = /cat-\w+/gi;
        var aux_regex_a;
        while (aux_regex_a = aux_regex.exec(portclass)) {
          if (aux_regex_a) {
            excerptContent_extraClasses += ' ' + aux_regex_a[0];
          }

        }


        zfolioMain._tcon_content = zfolioMain._excerptContent_initialPortItem.find('.the-content');

        let aux_excerpt_content_con = '<div class="' + VIEW_ISOTOPE_ITEM_CLASS + ' excerpt-content-con' + excerptContent_extraClasses + ' transition-' + o.excerpt_con_transition + ' "';


        if (zfolioMain._excerptContent_initialPortItem) {

          let ind3 = Number(zfolioMain._excerptContent_initialPortItem.attr('data-sort'));


          aux_excerpt_content_con += ' data-sort="' + (ind3 + 1) + '"';


        }


        aux_excerpt_content_con += '><div class="' + zfolioMain._tcon_content.attr('class') + '" style="">' + zfolioMain._tcon_content.html() + '<div class="close-btn">x</div></div></div>';


        if (_tcon_next.length > 0) {
          // -- even if the-content div is display: none, the height can still be calculated


          _tcon_next.before(aux_excerpt_content_con);

        } else {
          zfolioMain.$itemsCon.append(aux_excerpt_content_con);
        }


        zfolioMain._excerptContentCon = zfolioMain.cthis.find('.excerpt-content-con').eq(0);
        zfolioMain._excerptContent = zfolioMain._excerptContentCon.find('.excerpt-content').eq(0);
        setTimeout(function () {

          if (zfolioMain._excerptContent.removeClass) {

            zfolioMain._excerptContent.removeClass('transitioning-in')
          }
        }, 800)


        window.dzszfl_execute_target = zfolioMain._excerptContent;


        zfolioMain._excerptContent.find('.toexecute').each(function () {
          var _t2 = $(this);
          var aux = (_t2.html());

          if (!_t2.hasClass('executed')) {


            try {


              if (aux.indexOf('{') === 0) {

                var arr = JSON.parse(aux);
                if (arr.type === 'transform_slider_con') {
                  window.dzsas_init(window.dzszfl_execute_target.find(".slider-con .advancedscroller"), arr);
                }

                if (arr.type === 'item_excerpt_setup') {
                  window.dzsas_init(window.dzszfl_execute_target.find(".advancedscroller"), arr);
                }
              } else {
                eval(aux);
              }


            } catch (err) {
              console.info("ERROR PARSING", err, aux);
            }


            _t2.addClass('executed');
          }
        });


        if (zfolioMain._excerptContent.find('.advancedscroller').length === 0) {
          actually_open_it();
        } else {


          var inter_aux = setInterval(function () {


            if (zfolioMain._excerptContent) {

              if (zfolioMain._excerptContent && zfolioMain._excerptContent.find('.advancedscroller').eq(0).hasClass('loaded')) {
                actually_open_it();
                clearInterval(inter_aux);
              } else {

              }
            } else {
            }
          }, 100)
        }


        function actually_open_it() {
          var args = {
            calculate_dims_init: false
            , calculate_excerpt_con: true
            , excerpt_con_noanimation: false

          };


          zfolioMain._excerptContent.css({
            'height': 0
          });


          var delaytime = 100;
          if (o.excerpt_con_transition === 'wipe') {
            delaytime = 100;
          }

          handle_resize(null, {
            calculate_dims_init: true
            , calculate_excerpt_con: true
            , excerpt_con_noanimation: true

          });
          setTimeout(function () {

            if (zfolioMain._excerptContent.find('.advancedscroller').length > 0) {

              zfolioMain._excerptContent.find('.advancedscroller').each(function () {
                var _t = $(this);

                if (_t.get(0) && _t.get(0).api_force_resize) {
                  var args = {};

                  if (_t.attr('data-defaultheight')) {

                    args.calculate_auto_height_default_h = Number(_t.attr('data-defaultheight'));
                  }
                  _t.get(0).api_force_resize(null, args);
                }
              })
            }


            var auxh = zfolioMain._excerptContent.children('.dzs-colcontainer').outerHeight();


            var delaytime2 = 500;


            if (zfolioMain._excerptContent.find('.advancedscroller').length > 0) {
              auxh -= 2;
            }


            if (zfolioMain._tcon_content.hasClass('skin-qucreative')) {


              zfolioMain._excerptContent.css({
                'height': auxh
              });
              zfolioMain._excerptContentCon.css({
                'height': auxh
              });

              if (o.excerpt_con_transition === 'zoom') {
                zfolioMain._excerptContentCon.css({
                  'height': auxh
                });


                zfolioMain._excerptContent.css({
                  'height': auxh
                });
              } else {


                zfolioMain._excerptContentCon.css({
                  'height': auxh
                });


                zfolioMain._excerptContent.css({
                  'height': auxh
                });

                setTimeout(function () {

                  const $scrollerScrollTop = $('.scroller-con.type-scrollTop');
                  var aux = zfolioMain._excerptContent.offset().top - 100;
                  if ($scrollerScrollTop.get(0) && $scrollerScrollTop.get(0).api_scrolly_to) {

                    $scrollerScrollTop.get(0).api_scrolly_to(aux);
                  } else {

                    $('html, body').css({
                      scrollTop: aux
                    }, 300);
                  }


                }, 700)

              }
              excerpt_content_resize_vplayer();


            } else {

              zfolioMain._excerptContent.css({
                'height': zfolioMain._excerptContent.children('.dzs-colcontainer').outerHeight() + 40 * 2
              });
              zfolioMain._excerptContentCon.css({
                'height': zfolioMain._excerptContent.children('.dzs-colcontainer').outerHeight() + 40 * 2
              });
            }


            setTimeout(function () {

              zfolioMain._excerptContentCon.addClass('placed');

            }, delaytime2);


          }, delaytime);

          setTimeout(function () {

            var args = {
              calculate_dims_init: true
              , calculate_excerpt_con: true

            };

            handle_resize(null, args);
          }, 1000);

          zfolioMain._excerptContent.prepend(`<style>#` + zfolioMain.htmlIdentifier + '.dzsportfolio .excerpt-content:before{ left:' + (zfolioMain._excerptContent_initialPortItem.offset().left - zfolioMain.cthis.offset().left + zfolioMain._excerptContent_initialPortItem.outerWidth() / 2 - 8) + 'px; }</style>')

          zfolioMain._excerptContent_initialPortItem.addClass('active');


          zfolioMain._excerptContent.find('.vplayer-tobe.auto-init-from-q').each(function () {
            var _t2 = $(this);

            if (window.dzsvp_init) {

              var args = {
                settings_youtube_usecustomskin: "off"
                , init_each: true
                , controls_out_opacity: "1"
                , controls_normal_opacity: "1"
                , cueVideo: "off"
              };


              if (window.qucreative_options && window.qucreative_options.video_player_settings) {
                args = $.extend(args, window.qucreative_options.video_player_settings);
              }


              window.dzsvp_init(_t2, args)
            }
          })


          zfolioMain._excerptContent.find('.close-btn').bind('click', contentOpener_close);


          if ((o.settings_mode === 'isotope') && $.fn.isotope && zfolioMain.$itemsCon.hasClass('isotoped')) {

            delaytime = 300;
            if (o.excerpt_con_transition === 'wipe') {
              delaytime = 101;
            }

            setTimeout(function () {

              zfolioMain._excerptContentCon.addClass('isotoped');
              zfolioMain.$itemsCon.isotope('insert', zfolioMain._excerptContentCon);


              zfolioMain.$itemsCon.isotope('layout');

            }, delaytime);


          }

          delaytime = 700;
          if (o.excerpt_con_transition === 'wipe') {
            delaytime = 100;
          }

          setTimeout(function () {
            zfolioMain._excerptContent.addClass('placed');
          }, delaytime);

          setTimeout(function () {

            const $mainContainer = $('.main-container');
            // -- scroller resize
            if ($mainContainer.eq(0).get(0) && $mainContainer.eq(0).get(0).api_toggle_resize) {
              $mainContainer.eq(0).get(0).api_toggle_resize();
            }
          }, 300);
        }


        return false;
      }

      function contentOpener_close() {


        if (zfolioMain._excerptContentCon || zfolioMain._excerptContent) {
          zfolioMain._excerptContent.removeClass('placed');
          zfolioMain._excerptContent_initialPortItem.removeClass('active');

          if (o.excerpt_con_transition === 'wipe') {

            setTimeout(function () {

              zfolioMain._excerptContentCon.css({
                'height': 0
                , 'margin-bottom': 0
              });

              if (zfolioMain.$itemsCon.hasClass('isotoped')) {
                zfolioMain.$itemsCon.isotope('layout');
              }
            }, 100)


            zfolioMain._excerptContent.css({
              'height': 0
            });

          }

          var delaytime = 700;

          if (o.excerpt_con_transition === 'wipe') {
            delaytime = 400;
          }

          setTimeout(function () {

            if ((o.settings_mode === 'isotope' ) && $.fn.isotope && zfolioMain.$itemsCon.hasClass('isotoped')) {

              zfolioMain.$itemsCon.isotope('remove', zfolioMain._excerptContentCon);
            }

            if (zfolioMain._excerptContentCon) {

              zfolioMain._excerptContentCon.remove();
              zfolioMain._excerptContentCon = null;
            }
            zfolioMain._excerptContent_initialPortItem = null
            zfolioMain._excerptContent = null;

            handle_resize();
          }, delaytime);
        }


        setTimeout(function () {

          const $mainContainer = $('.main-container');
          if ($mainContainer.eq(0).get(0) && $mainContainer.eq(0).get(0).api_toggle_resize) {
            $mainContainer.eq(0).get(0).api_toggle_resize();
          }
        }, 300);
      }


      return this;
    })
  }

  window.dzszfl_init = function (selector, settings) {
    $(selector).zfolio(settings);
  };
})(jQuery);


jQuery(document).ready(function ($) {

  dzszfl_init('.zfolio.auto-init');

});








